import { useMutation } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

export const useRegisterStudent = () => {
  return useMutation({
    mutationFn: async ({ studentToken }: { studentToken: string; userId?: string }) => {
      const response = await ApiClient.api.purchaseControllerRegisterStudent({
        studentToken,
      });

      return response.data;
    },
  });
};
